export const ResetIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="24"
    width="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3a9 9 0 109 9 9.01 9.01 0 00-9-9zm3.259 11.28a.691.691 0 11-.98.979L12 12.979l-2.28 2.28a.691.691 0 01-1.182-.49.693.693 0 01.203-.49L11.021 12l-2.28-2.28a.693.693 0 01.98-.979L12 11.021l2.28-2.28a.692.692 0 11.979.98L12.979 12l2.28 2.28z"
      fill="var(--text-tetriary-transparent)"
    />
  </svg>
);
